import { Component, OnInit } from "@angular/core";
import { NavParams, ViewController } from "ionic-angular";
import { RodeoEvent } from "../../../../../model/rodeoEvent";
import { Rodeo } from "../../../../../model/rodeo";
import { PayoutConfig } from "../../../../../model/payoutConfig";
import { PointsDomainService } from "../../../../../services/points/points.domian.service";
import { PointStatsApiService } from "../../../../../services/points/pointStats.api.service";
import { MonitoringService } from "../../../../../services/AppInsights/monitoring-service";
import { RodeoPointSeriesNominationsDto } from "../../../../../lib/types/RodeoPointSeriesNominationsDto";

@Component({
    selector: 'point-generation-modal',
    templateUrl: 'point-generation-modal.component.html'
})
export class PointGenerationModalComponent implements OnInit {
    payouts;
    rodeoEvent: RodeoEvent;
    rodeo: Rodeo;
    winnerPayouts: PayoutConfig[];
    useScoreValue: boolean;
    pendingChanges: boolean;
    loading: boolean;
    generatedPointStats;
    showError: boolean;
    rodeoPointSeriesNominations : RodeoPointSeriesNominationsDto[] = [];
    showingNominations : boolean;

    constructor(
        private navParams: NavParams,
        private viewCtrl: ViewController,
        private pointsDomainService: PointsDomainService,
        private pointStatsApiService: PointStatsApiService,
        private monitoringService: MonitoringService,
    ) {
        this.payouts = navParams.data.pointStatsGenerationStatus.validPayoutConfig;
        this.rodeo = navParams.data.rodeo;
        this.winnerPayouts = navParams.data.winnerPayouts;
        this.useScoreValue = navParams.data.useScoreValue;
        this.rodeoEvent = navParams.data.rodeoEvent;
        this.payouts = this.payouts.map(p => {
            const pointStats = p.trackedPointAssigments.map(pa => {
                const correspondingPointSeries = p.pointSeries.find(ps => ps.id === pa.pointSeriesId);
                const pointSeriesName = correspondingPointSeries.name;
                const enableNominations = correspondingPointSeries.enableNominations;
                const maxRodeoNominations = correspondingPointSeries.maxRodeoNominations;
                return {
                    ...pa,
                    pointSeriesName,
                    enableNominations,
                    maxRodeoNominations,
                }
            });
            return {
                ...p,
                trackedPointAssigments: pointStats,
            }
        })
    }

    async ngOnInit(): Promise<void> {
        if (this.rodeo.pointsNominationEnabled) {
            this.loading = true;
            const rodeoNominations = await this.pointStatsApiService.getRodeoNomination(this.rodeo.id);
            this.rodeoPointSeriesNominations = rodeoNominations;
            this.loading = false;
        }
        
    }

    toggleNominationsVisibility() {
        this.showingNominations = !this.showingNominations;
    }

    dismiss() {
        this.viewCtrl.dismiss({}, 'cancel');
    }

    generate() {
        const pointStats = this.pointsDomainService.generatePointStats(
            this.rodeo, this.rodeoEvent, this.winnerPayouts, this.useScoreValue, this.rodeoPointSeriesNominations
        );
        const pointStatsTiesResolved = this.pointsDomainService.splitPointsForTies(pointStats);
        const pointStatsSortedPlaces = this.pointsDomainService.handleTiePlaces(pointStatsTiesResolved);

        this.payouts = this.payouts.map(p => {
            const pointStats = p.trackedPointAssigments.map(pa => {
                const generatedPointStats = pointStatsSortedPlaces.filter(ps => ps.pointSeriesId === pa.pointSeriesId && ps.payoutConfigId === p.id);
                return {
                    ...pa,
                    generatedPointStats,
                }
            });
            return {
                ...p,
                trackedPointAssigments: pointStats,
            }
        })
        
        this.generatedPointStats = pointStatsSortedPlaces;
        this.pendingChanges = true;

    }

    async savePoints() {
        
        this.loading = true;
        this.showError = false;
        try {
            await this.pointStatsApiService.savePointStats(this.generatedPointStats);
        } catch (ex) {
            this.monitoringService.logException(ex);
            this.showError = true;
            this.loading = false;
            console.error(ex);
            return;
        } 
        this.loading = false;
        this.pendingChanges = false;
        this.viewCtrl.dismiss({

        }, 'confirm')
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/results/points-generation-modal/point-generation-modal.component.ts